export const isRecordHasKey = <Key extends string>(
  content: Record<string, unknown>,
  key: Key,
): content is Record<string, unknown> & Record<Key, unknown> => key in content;
